import React, { Fragment } from 'react';
import {
  ExpandableTableHeaderItem,
  PaginationContainer,
  StyledTable,
  TableBody,
  TableBodyItemEmpty,
  TableBodyRow,
  TableContainer,
  TableHeader,
  TableHeaderItem,
  TableHeaderRow,
  TableWrapper,
} from './Table.styles';
import Pagination from './Pagination/Pagination';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LoadingPurple } from '../../assets/icons/loader-purple.svg';

const Table = ({
  currentPage,
  totalCount,
  perPage,
  bigHeaderWidth,
  setPage,
  children,
  marginTop,
  headerInformation,
  noDataContent,
  lastColumnAligned,
  expandable,
  height,
  dataLoading,
  width,
  minWidth,
  maxHeight,
  scroll,
  centerText,
  flex,
  param,
}) => {
  const locale = 'en';
  const ar = locale === 'ar';
  const { t } = useTranslation();

  return (
    <TableContainer
      style={{
        marginTop: marginTop,
      }}>
      <TableWrapper
        style={{
          width: width,
          minHeight: height,
          maxHeight: maxHeight,
          overflow: scroll,
          minWidth: minWidth,
          flex: flex,
        }}>
        <StyledTable>
          {headerInformation && (
            <TableHeader>
              <TableHeaderRow>
                {expandable && <ExpandableTableHeaderItem />}
                {headerInformation.map((item, index) => {
                  return (
                    <TableHeaderItem $big={bigHeaderWidth} key={index} $centerText={centerText} $lastColumnAligned={lastColumnAligned}>
                      {t(item.label)}
                    </TableHeaderItem>
                  );
                })}
              </TableHeaderRow>
            </TableHeader>
          )}
          <TableBody>
            {!dataLoading ? (
              children?.length ? (
                children?.map((child, index) => {
                  return expandable ? <Fragment key={index}>{child}</Fragment> : <Fragment key={index}>{child}</Fragment>;
                })
              ) : (
                <TableBodyRow $empty>
                  <TableBodyItemEmpty $textcenter>{t(noDataContent)}</TableBodyItemEmpty>
                </TableBodyRow>
              )
            ) : (
              <TableBodyRow>
                <TableBodyItemEmpty $textcenter>
                  <LoadingPurple height={30} width={30} />
                </TableBodyItemEmpty>
              </TableBodyRow>
            )}
          </TableBody>
        </StyledTable>
        {totalCount > perPage && (
          <PaginationContainer $ar={ar}>
            <Pagination
              ar={ar}
              currentPage={currentPage}
              totalCount={totalCount}
              pageSize={perPage}
              onPageChange={page => {
                setPage(page, param);
              }}
            />
          </PaginationContainer>
        )}
      </TableWrapper>
    </TableContainer>
  );
};

export default Table;
